<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <b-modal
        id="filter"
        size="xl"
        no-close-on-backdrop
        hide-footer
        title="FILTRAR"
      >
        <div class="row">
          <div class="col-md-12">
            <label>TIPO</label>
            <select v-model="type" class="form-control">
              <option value="EVOLUCAO">FEZ EVOLUÇÃO</option>
              <option value="NAO_EVOLUCAO">NÃO FEZ EVOLUÇÃO</option>
            </select>
          </div>
          <div class="col-xl-3 col-sm-3 col-md-3 col-sm-12 col-12">
            <label>TIPO EVOLUÇÕES</label>
            <v-select
              v-model="evolutions_types"
              :items="evolution_types"
              item-text="name"
              item-value="type"
              multiple
              clearable
              outlined
              ref="residentSelect"
              @change="closeSelect"
              class="modern-select"
              placeholder="Selecione os tipos de evolução"
            />
          </div>
          <div class="col-xl-4 col-sm-4 col-md-4 col-sm-4 col-4 text-center">
            <label>FILTRAR POR RESIDENTES</label>
            <div class="d-flex align-items-center justify-content-center">
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_active"
                  @change="getResidents"
                  id="resident_active"
                />
                <label class="form-check-label" for="resident_active">
                  ATIVOS
                </label>
              </div>
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_not_active"
                  @change="getResidents"
                  id="resident_not_active"
                />
                <label class="form-check-label" for="resident_not_active">
                  INATIVOS
                </label>
              </div>
            </div>
          </div>
          <div class="col-xl-5 col-sm-5 col-md-5 col-sm-12 col-12">
            <label>Residente</label>
            <select v-model="resident_id" class="form-control">
              <option :value="null">SELECIONE...</option>
              <option
                v-if="
                  rest_home_allow_home_care != 1 &&
                  user_allow_home_care != 1 &&
                  type == 'NAO_EVOLUCAO'
                "
                value="TODOS"
              >
                TODOS OS RESIDENTES
              </option>
              <option
                v-for="resident in residents"
                :key="resident.id"
                :value="resident.id"
              >
                {{ String(resident.name).toUpperCase() }} -
                {{ String(resident.status_type_name).toUpperCase() }}
              </option>
            </select>
          </div>
          <div class="col-xl-3 col-sm-3 col-md-3 col-sm-12 col-12">
            <label>Status</label>
            <select v-model="status" class="form-control">
              <option
                v-for="item in typesFilterByStatus"
                :key="item.id"
                :value="item.id"
              >
                {{ String(item.name).toUpperCase() }}
              </option>
            </select>
          </div>
          <div class="col-xl-3 col-sm-3 col-md-3 col-sm-6 col-12">
            <label>Data inicial</label>
            <input type="date" v-model="dtInit" class="form-control" />
            <small
              >Informe um intervalo de até 31 dias entre a data inicial e
              final.</small
            >
          </div>
          <div class="col-xl-3 col-sm-3 col-md-3 col-sm-6 col-12">
            <label>Data final</label>
            <input type="date" v-model="dtEnd" class="form-control" />
          </div>
          <div class="col-xl-3 col-sm-3 col-md-3 col-sm-12 col-12">
            <label>Mostrar anexos?</label>
            <select v-model="evolution_has_attachment" class="form-control">
              <option value="NAO">NÃO</option>
              <option value="SIM">SIM</option>
            </select>
          </div>
          <div class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn
              :disabled="loading"
              @click="paginate()"
              class="btn-filter"
              type="relief"
              ><i class="fas fa-filter mr-2 text-twenty"></i>
              {{ loading ? "CARREGANDO" : "FILTRAR" }}
            </v-btn>
          </div>
        </div>
      </b-modal>

      <div class="row">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return mb-3" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-7 col-lg-6 col-md-6 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">
            RELATÓRIO: EVOLUÇÃO MULTIDISCIPLINAR
          </h1>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="evolutions.length == 0"
            @click="handleToPrint"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>

        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
          v-if="evolutions.length > 0"
        >
          <h6 class="mb-0 upper-text worksansr check-text-center">
            <p class="m-0 text-center" v-if="type == 'EVOLUCAO'">
              Evoluções realizadas
            </p>
            <p class="m-0 text-center" v-if="type == 'NAO_EVOLUCAO'">
              Evoluções não realizadas
            </p>
            FILTRANDO:

            <div
              v-for="evolution_name in evolutions_names"
              :key="evolution_name.id"
              :value="evolution_name.id"
            >
              <strong>{{ evolution_name }}</strong> |
            </div>

            <span><strong>RESIDENTE</strong> | </span>
            <span
              ><strong>STATUS: {{ status }}</strong> |
            </span>
            <span
              ><strong>DATA INICIAL: {{ formatDate(dtInit, false) }}</strong> |
            </span>
            <span
              ><strong>DATA FINAL: {{ formatDate(dtEnd, false) }}</strong> |
            </span>
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="evolutions.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <div v-show="evolutions.length > 0">
          <v-data-table
            v-show="return_type == 'EVOLUCAO'"
            dense
            :headers="headers_type_evolution"
            :items="evolutions"
            item-key="id"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.type`]="{ item }">
              {{ item.type_evolution }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span
                :class="[item.status == 1 ? 'text-success' : 'text-danger']"
              >
                {{ item.status == 1 ? "ATIVO" : "APAGADO" }}
              </span>
            </template>
            <template v-slot:[`item.text`]="{ item }">
              {{
                String(item.text).length > 25
                  ? `${String(item.text).substring(0, 25)}...`
                  : item.text
              }}
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              {{ formatDate(item.created_at) }}
              <b-modal
                size="md"
                no-close-on-backdrop
                hide-footer
                :id="`evolution-${item.id}`"
                title="EVOLUÇÃO"
              >
                <div class="row">
                  <div class="col-md-12">
                    <textarea
                      disabled
                      class="form-control"
                      v-model="item.text"
                      rows="10"
                    />
                  </div>
                </div>

                <div v-if="item.evolution_complement" class="col-md-12">
                <span> Complementos: </span>

                <div class="mb-2">
                  <textarea
                    disabled
                    class="form-control mr-1"
                    :value="item.evolution_complement"
                    rows="5"
                    max-rows="10"
                  />
                </div>
              </div>
              </b-modal>
            </template>
          </v-data-table>
          <v-data-table
            v-show="return_type == 'NAO_EVOLUCAO'"
            dense
            :headers="headers_type_not_evolution"
            :items="evolutions"
            item-key="id"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template v-slot:[`item.type`]="{ item }">
              {{ item.type_evolution }}
            </template>
            <template v-slot:[`item.text`]="{ item }">
              {{ String(item.text) }}
            </template>
          </v-data-table>
        </div>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import routes from "../../routes";

import { formatDate } from "../../lib/format";

import permission from "../../lib/permission";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import ErrorsMessages from "../Components/ErrorsMessages";

import NavBar from "../NavBar";

import { restore, save, userData } from "../../lib/functions";

export default {
  name: "ReportsEvolution",
  components: {
    NavBar,
    ErrorsMessages,
    AuthBySessionExpired,
  },
  data() {
    return {
      evolution_has_attachment: "NAO",
      type: "EVOLUCAO",
      return_type: "EVOLUCAO",
      resident_active: true,
      resident_not_active: false,
      nurse: false,
      doctor: false,
      nutritionist: false,
      physiotherapist: false,
      psychologist: false,
      speech_therapist: false,
      occupational_therapist: false,
      music_therapy: false,
      social_worker: false,
      physical_educator: false,
      educators_and_pedagogues: false,
      dentist: false,
      caregiver: false,
      technical_manager: false,
      dtInit: "",
      dtEnd: "",
      status: "TODOS",
      resident_id: null,
      headers_type_evolution: [
        { text: "TIPO", value: "type" },
        { text: "RESIDENTE", value: "resident_name" },
        { text: "CRIADO POR", value: "user_name" },
        { text: "DATA CADASTRO", value: "created_at" },
        { text: "STATUS", value: "status" },
      ],
      headers_type_not_evolution: [
        { text: "TIPO", value: "type" },
        { text: "RESIDENTE", value: "resident_name" },
      ],
      typesFilterByStatus: [
        { id: "TODOS", name: "Filtrar por todos" },
        { id: "EXCLUIDO", name: "Filtrar apenas excluidas" },
        {
          id: "ATIVO",
          name: "Filtrar apenas ativas",
        },
      ],
      resident_ids: [],
      residents: [],
      evolutions: [],
      evolutions_types: [],
      evolution_types: [],
      errors: [],
      loading: false,

      user_allow_home_care: 0,
      rest_home_allow_home_care: 0,
    };
  },

  created() {
    this.retrieve();
  },

  computed: {
    evolutions_names() {
      return this.evolution_types
        .filter((item) => this.evolutions_types.includes(item.type))
        .map((item) => item.name);
    },
  },

  methods: {
    permission,
    formatDate,
    saveState() {
      save(this, "ReportsEvolution", [
        "evolution_has_attachment",
        "type",
        "return_type",
        "nurse",
        "doctor",
        "nutritionist",
        "physiotherapist",
        "psychologist",
        "speech_therapist",
        "occupational_therapist",
        "music_therapy",
        "social_worker",
        "physical_educator",
        "educators_and_pedagogues",
        "dentist",
        "caregiver",
        "technical_manager",
        "resident_id",
        "status",
        "dtInit",
        "dtEnd",
      ]);
    },
    handleClickRowTable({ id }) {
      this.$bvModal.show(`evolution-${id}`);
    },
    async retrieve() {
      this.getViewersEvolutionsActive();

      const { user } = userData();

      this.user_allow_home_care = user.allow_home_care;
      this.rest_home_allow_home_care = user.rest_home_allow_home_care;

      restore(this, "ReportsEvolution");
      await this.getResidents();
      if (this.resident_id) {
        await this.paginate();
      }
      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },
    async getResidents() {
      try {
        let { resident_active, resident_not_active } = this;

        let status = "ATIVO";

        if (resident_active && resident_not_active) {
          status = "ALL";
        } else if (!resident_active && resident_not_active) {
          status = "INATIVO";
        } else if (!resident_active && !resident_not_active) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe residentes ativos, inativos ou ambos",
            },
          ];
          this.residents = [];
          return;
        }

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async paginate() {
      try {
        const {
          type,
          dtInit,
          dtEnd,
          status,
          resident_id,
          evolutions_types,
          resident_active,
          resident_not_active,
        } = this;

        if (type == "NAO_EVOLUCAO") {
          if (evolutions_types.length > 1 && resident_id == "TODOS") {
            this.errors = [
              "Informe apenas um tipo de evolução para a filtragem de (NÃO FEZ EVOLUÇÃO) e (TODOS OS RESIDENTES)",
            ];
            return;
          }
        }

        let params = {
          type,
          dtInit,
          dtEnd,
          status,
          resident_id,
          evolutions_types,
          resident_active,
          resident_not_active,
        };

        this.loading = true;

        const response = await api.get("/rest-home/report/evolution/filter", {
          params,
        });

        const { evolutions, return_type, error, errors } = response.data;

        this.return_type = return_type;

        if (error) {
          this.evolutions = [];
          this.errors = errors;
        } else {
          this.errors = [];
          this.evolutions = evolutions;
          let resident_ids = [];
          for (let ev of evolutions) {
            resident_ids.push(ev.resident_id);
          }
          this.resident_ids = resident_ids;
          this.$bvModal.hide("filter");
        }

        this.saveState();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getViewersEvolutionsActive() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/evolutions/settings/actives"
        );

        const { evolution_types } = response.data;

        this.evolution_types = evolution_types;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    handleToPrint() {
      const {
        type,
        return_type,
        evolutions,
        resident_ids,
        evolutions_types,
        dtInit,
        dtEnd,
        evolution_has_attachment,
      } = this;

      let ids = [];
      if (return_type == "EVOLUCAO") {
        for (const item of evolutions) {
          ids.push(item.id);
        }
      }

      let resident_ids_added = [];
      for (let res of resident_ids) {
        if (!resident_ids_added.includes(res)) {
          resident_ids_added.push(res);
        }
      }

      let route = this.$router.resolve({
        name: "report_evolution",
        params: {
          type,
          types: evolutions_types.join(","),
          resident_ids: resident_ids_added.join(","),
          ids: return_type == "EVOLUCAO" ? ids.join(",") : false,
          dtInit,
          dtEnd,
        },
        query: {
          evolution_has_attachment,
        },
      });

      window.open(route.href, "_blank");
    },

    handleToBack: () => routes.go(-1),

    closeSelect() {
      this.$refs.residentSelect.blur();
    },
  },
};
</script>
